varying vec2 vUv;

void main()
{
    vUv = uv;
    vec3 newPosition = position;
    newPosition.z = 1.0;
    gl_Position = vec4(newPosition, 1.0);
}
